import {
  Contract,
  ContractItem,
  getPriceRaiseCachedBox,
  getPriceRaiseContractUnitPrice,
  getPriceRaiseCustomerName,
  getPriceRaisePercent,
} from 'entities/Contract';
import { getSizeCodeTypeString } from 'entities/SizeCode';
import { getClientDateFormat } from 'shared/utils/helpers/getDateFormat';

export interface PriceRaiseAcceptDetailsExtras {
  currentPrice?: number;
  contractItem?: Nullable<ContractItem>;
  priceRaiseDate?: string;
}

interface PriceRaiseAcceptDetail {
  label: string;
  value: string;
}

export const getPriceRaiseAcceptDetails = (
  contract: Contract,
  proposedPrice: number,
  currencySymbol: string,
  t: (key: string) => string,
  extras?: PriceRaiseAcceptDetailsExtras,
): PriceRaiseAcceptDetail[] => {
  const cachedBox = getPriceRaiseCachedBox(contract, extras?.contractItem);
  const currentPrice = extras?.currentPrice ?? getPriceRaiseContractUnitPrice(contract, cachedBox);
  const percent = getPriceRaisePercent(currentPrice, proposedPrice);
  const percentLabel = `${percent > 0 ? '+' : ''}${percent}%`;
  const sizeType = getSizeCodeTypeString(cachedBox?.sizeCode?.sizeCodeType);
  const sizeValue = [cachedBox?.square != null ? `${cachedBox.square} ${sizeType}`.trim() : '', cachedBox?.name || '']
    .filter(Boolean)
    .join(' | ');
  const priceRaiseDate = extras?.priceRaiseDate || (contract as Contract & { priceRaiseDate?: string }).priceRaiseDate;

  return [
    { label: t('Warehouse'), value: contract.warehouse?.name || '' },
    { label: t('Contract'), value: `#${contract.contractNumber}` },
    { label: t('Start date'), value: getClientDateFormat(contract.startDate) },
    { label: t('Customer'), value: [getPriceRaiseCustomerName(contract), contract.user?.email || ''].filter(Boolean).join('\n') },
    { label: t('Size / Unit'), value: sizeValue },
    { label: t('Current price'), value: `${currentPrice} ${currencySymbol}` },
    { label: t('New price'), value: `${proposedPrice} ${currencySymbol} (${percentLabel})` },
    { label: t('Price raise date'), value: priceRaiseDate ? getClientDateFormat(priceRaiseDate) : '' },
  ];
};
